
import { Injectable } from '@angular/core';

export interface AppBranding {
  appLogo?: string;
  logo?: string;
  primaryColor?: string;
  themeFont?: string;
}

@Injectable({
  providedIn: 'root'
})

export class BrandingService {

    public appBranding: AppBranding = {}

    constructor() {

    }

    resetBranding() {
      this.appBranding = {};
    }
}